import _axios from "../../libs/axios";
import { NotificationManager } from "../../components/common/react-notifications";
import moment from "moment";
export default (context) => {
  return {
    config: {
      resource: "admTracking",
      pageSize: 40,
      list: false,
      remap: (r) => {
        r.data.Results.map(d => d.notifOn = d.notifOn ? "Sí" : null)
        return r
      },
      remapRow: (form, data, action) => {
        if (data) form.status = data.status
        form.grado = form.sectionName.label
        form.user = form.userId.label
        form.dateFrom = moment(form.dateFrom).format('YYYY-MM-DD HH:mm')
        form.masterName = action === "create" && context.props.userAdmin.role === '5' ? (context.props.userAdmin.name + ' ' + context.props.userAdmin.last) : form.masterId.label
        form.notifOn = form.notify ? "Sí" : form.notifOn ? "Sí" : null
        return form
      }
    },

    actions: {
      create: true,
      edit: true,
      delete: true,
      print: true,
      export: true,
      search: true
    },

    filter: {
      fields: [
        {
          name: "type",
          value: "behavior",
          type: "hidden",
        },
        {
          name: "periodId",
          value: { value: "0", label: "Actual" },
          type: "select",
          label: "Periodo",
          opts: {
            style: 'float-label',
            path: "/admPeriod/get?pick=true"
          }
        },
        {
          name: "superSectionId",
          value: null,
          type: "select",
          label: "Grado",
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true"
          }
        },
        {
          name: "sectionId",
          value: "",
          type: "select",
          label: "Sección",
          parent: "superSectionId",
          opts: {
            style: 'float-label',
            path: () => { return "/admSection/get?pick=true&parentId=" + context.state.formFilter.superSectionId }
          }
        },
        {
          name: "userId",
          value: "",
          type: "select",
          label: "Alumno",
          rules: 'required',
          parent: "sectionId",
          opts: {
            style: 'float-label',
            searchOnline: true,
            withImg: true,
            path: () => { return "/admStudent/get?pick=true&sectionId=" + context.state.formFilter.sectionId }
          }
        },
        {
          type: "daterange"
        },
        {
          name: "status",
          value: -1,
          type: "select",
          label: "Estado",
          rules: 'required',
          opts: {
            style: 'float-label',
            items: [
              {
                value: -1,
                label: "[Todos]"
              },
              {
                value: 0,
                label: "Iniciado"
              },
              {
                value: 1,
                label: "En proceso"
              },
              {
                value: 2,
                label: "Terminado"
              },
            ]
          }
        }
      ],
      buttons: [
        {
          label: 'Aplicar filtro',
          renderIf: (ctx) => { return ctx.state.periodId || ctx.state.superSectionId || ctx.state.userId || ctx.state.from || ctx.state.to },
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      detailGrid: () => {
        return context.state.idItemSelected ?
        {
          module: 'admBookingList', 
          filterBy: (ctx) => { return { userId: ctx.state.userId, IN: ctx.state.bookings ? JSON.stringify(ctx.state.bookings) : "[]" } },
          embeded: (c) => {
            process.nextTick(() => { c.setState({ dataTableList: true }) })
            return {
              config: {
                resource: "admBooking", 
                pageSize: 20
              },
              actions: {
                create: false,
                edit: true,
                delete: false,
                search: false,
                print: false,
                export: false
              },
              form: {
                fields: [
                  {
                    col: 6,
                    name: "userName",
                    type: "text",
                    label: "Alumno",
                    opts: {
                      style: 'float-label',
                    },
                    disabled: true
                  },
                  {
                    col: 6,
                    name: "resourceName",
                    type: "text",
                    label: "Profesor",
                    opts: {
                      style: 'float-label',
                    },
                    disabled: true
                  },
                  {
                    col: 6,
                    name: "dtDate",
                    type: "date",
                    label: "Fecha",
                    opts: {
                      style: 'float-label',
                    },
                    disabled: true
                  },
                  {
                    col: 6,
                    name: "status",
                    value: 0,
                    type: "select",
                    label: "Estado",
                    rules: 'required',
                    opts: {
                      style: 'float-label',
                      items: [
                        {
                          value: 0,
                          label: "Separada"
                        },
                        {
                          value: 1,
                          label: "Confirmada"
                        },
                        {
                          value: 2,
                          label: "Completada"
                        },
                      ]
                    },
                    disabled: true
                  },
                  {
                    col: 12,
                    name: "notes",
                    type: "textarea",
                    label: "Anotaciones / Comentarios",
                    opts: {
                      style: 'float-label',
                    }
                  },
                  {
                    col: 12,
                    name: "notesCompleted",
                    type: "textarea",
                    label: "Informe",
                    opts: {
                      style: 'float-label',
                    }
                  }
                ]
              },
              columns: [         
                {
                  Header: "Fecha",
                  accessor: "dtDate",
                  isDate: true,
                  classList:'w-50'
                },
                {
                  Header: "Profesor",
                  accessor: "resourceName",
                  classList:'w-50'
                },
                {
                  Header: "Asunto",
                  accessor: "notes",
                  classList:'w-100'
                },
                {
                  Header: "Informe",
                  accessor: "notesCompleted",
                  classList:'w-100'
                }
              ]
            }
          }
        } : null
      },
      remapOne: (r) => {
        if (r.status >= 0) {
          r.data.periodId = { value: r.data.periodId, label: r.data.periodName }
          r.data.gradeName = { value: r.data.gradeName, label: r.data.gradeName }
          r.data.sectionName = { value: r.data.sectionName, label: r.data.sectionName }
          r.data.userId = { value: r.data.userId, label: r.data.userName }
          r.data.masterId = { value: r.data.masterId, label: r.data.masterName }
          r.data.labelNotifOn = `<div class="title-field mt-1">${r.data.notifOn ? "Notificado: Sí" : "Notificado: No"}</div>`  
        }
        return r
      },
      setValuesBeforePost: (v) => {
        v.values1.map(e => {
          e.selected = true
          e.ID = e.value
          e.name = e.label
          delete e.desc
          delete e.id
          delete e.img
          delete e.value
          delete e.label
          return e
        })

        v.sectionName = v.sectionName.value
        v.userId = v.userId.value
        v.masterId = context.state.idItemSelected ? v.masterId.value : (context.props.userAdmin.role === '5' ? context.props.userAdmin.ID : v.masterId.value)

        delete v.flags
        delete v.btn1
        delete v.notifOn
        return v
      },
      fields: [
        {
          name: "type",
          value: "behavior",
          type: "hidden",
        },
        {
          name: "status",
          value: 0,
          type: "hidden",
        },
        {
          col: 4,
          name: "periodId",
          value: { value: "0", label: "Actual" },
          type: "select",
          label: "Periodo",
          rules: 'required',
          opts: {
            style: 'float-label',
            path: "/admPeriod/get?pick=true"
          },
          disabled: () => { return context.state.idItemSelected ? true : false }
        },
        {
          col: 4,
          name: "gradeName",
          value: "",
          type: "select",
          label: "Grado",
          rules: 'required',
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true"
          },
          disabled: () => { return context.state.idItemSelected ? true : false }
        },
        {
          col: 4,
          name: "sectionName",
          value: "",
          type: "select",
          label: "Sección",
          rules: 'required',
          parent: 'gradeName',
          opts: {
            style: 'float-label',
            path: () => { return "/admSection/get?pick=true&parentId=" + context.state.form.gradeName },
            setOutput: v => v,
          },
          disabled: () => { return context.state.idItemSelected ? true : false }
        },
        {
          col: 6,
          name: "userId",
          value: "",
          type: "select",
          label: "Alumno",
          rules: 'required',
          parent: 'sectionName',
          opts: {
            style: 'float-label',
            searchOnline: true,
            withImg: true,
            path: () => { return "/admStudent/get?pick=true" + (context.state.form.sectionName ? "&sectionId=" + context.state.form.sectionName.value : "") },
            setOutput: v => v,
          },
          disabled: () => { return context.state.idItemSelected ? true : false }
        },
        {
          col: 6,
          name: "masterId",
          value: "",
          type: "select",
          label: "Profesor",
          rules: 'required',
          opts: {
            style: 'float-label',
            searchOnline: true,
            withImg: true,
            path: () => { return "/admStaff/get?pick=true" },
            setOutput: v => v,
          },
          renderIf: () => { return context.props.userAdmin.role !== '5' }
        },
        {
          col: 6,
          name: "dateFrom",
          value: "",
          type: "date",
          label: "Fecha",
          rules: 'required',
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 6,
          name: "values1",
          value: "",
          type: "select",
          label: "Valor relacionado",
          rules: 'required',
          opts: {
            style: 'float-label',
            isMulti: true,
            path: () => { return "general/getlist/trackingValues1" },
            remap: (r) => {
              return {
                data: {
                  Results: r.data.map(e => {
                    e.ID = e.id
                    return e
                  })
                },
                msg: r.msg,
                status: r.status
              }
            },
            setOutput: v => v
          }
        },
        {
          col: 12,
          name: "tab-1",
          value: false,
          type: "collapsible",
          label: "Descripción de la situación",
          childs: [
            {
              col: 12,
              name: "note1",
              value: "",
              type: "editor",
              label: "Descripción de la situación",
              rules: "required"
            }
          ]
        },
        {
          col: 12,
          name: "tab-2",
          value: false,
          type: "collapsible",
          label: "Testimonio del estudiante",
          childs: [
            {
              col: 12,
              name: "note2",
              value: "",
              type: "editor",
              label: "Testimonio del estudiante",
              rules: "required"
            }
          ]
        },
        {
          col: 4,
          name: "negative",
          value: "",
          type: "select",
          label: "Tipo",
          rules: 'required',
          opts: {
            style: 'float-label',
            items: [
              {label: 'Felicitación', value: false},
              {label: 'Oportunidad de Mejora', value: true}
            ]
          }
        },
        {
          col: 4,
          name: "readOn",
          value: "",
          type: "date",
          label: "Visto por padre(s)",
          opts: {
            style: 'float-label',
          },
          disabled: () => true,
          renderIf: () => { return context.state.idItemSelected }
        },
        {
          col: 4,
          name: "online",
          value: false,
          type: "select",
          label: "Tipo de informe",
          rules: 'required',
          opts: {
            style: 'float-label',
            items: [
              {label: 'Presencial', value: false}
              /* {label: 'Virtual', value: true} */
            ]
          },
          disabled: () => context.state.idItemSelected ? true : false,
        },
        {
          col: 4,
          name: "notify",
          value: false,
          type: "switch",
          label: "Notificar al padre de familia",
          renderIf: () => ['20', '100'].indexOf(context.props.userAdmin.role) > -1 // Solo mostrar si el usuario tiene tiene rol de "Coordinador de nivel" o "admin"
        },
        {
          name: "notifOn",
          value: null,
          type: "hidden",
        },
        {
          col: 4,
          name: "labelNotifOn",
          value: "",
          type: "label"
        },
        {
          col: 12,
          name: "tab-3",
          value: false,
          type: "collapsible",
          label: "Entrevista con el tutor",
          childs: [
            {
              col: 12,
              name: "note3",
              value: "",
              type: "editor",
              label: "Entrevista con el tutor"
            }
          ],
          renderIf: (ctx) => { return ctx.state.online === false }
        },
        {
          col: 12,
          name: "tab-4",
          value: false,
          type: "collapsible",
          label: "Entrevista con el coordinador de nivel",
          childs: [
            {
              col: 12,
              name: "note4",
              value: "",
              type: "editor",
              label: "Entrevista con el coordinador de nivel"
            }
          ],
          renderIf: (ctx) => { return ctx.state.online === false }
        },
        {
          col: 12,
          name: "tab-5",
          value: false,
          type: "collapsible",
          label: "Entrevista con el padre de familia",
          childs: [
            {
              col: 12,
              name: "note5",
              value: "",
              type: "editor",
              label: "Entrevista con el padre de familia"
            }
          ],
          renderIf: (ctx) => { return ctx.state.online === false }
        },
        {
          col: 12,
          name: "colEmpty1",
          type: "separator"
        },
        {
          col: 4,
          colxs: 4,
          name: "file1",
          value: "",
          type: "dropzone",
          label: "Adjunto 1",
          opts: {
            path: ()=> "admTracking/file"
          }
        },
        {
          col: 4,
          colxs: 4,
          name: "file2",
          value: "",
          type: "dropzone",
          label: "Adjunto 2",
          opts: {
            path: ()=> "admTracking/file"
          }
        },
        {
          col: 4,
          colxs: 4,
          name: "file3",
          value: "",
          type: "dropzone",
          label: "Adjunto 3",
          opts: {
            path: ()=> "admTracking/file"
          }
        },
        {
          col: 12,
          name: "bookings",
          value: null,
          type: "hidden",
          label: ""
        },
        {
          col: 12,
          name: "userName",
          value: "",
          type: "hidden",
          label: ""
        },
        {
          col: 12,
          label: "Descargar PDF",
          name: "downloadPDF",
          value: "",
          type: "button",
          onClick: () => {
            context.props.setLoader(true)
            _axios
              .get('admTracking/pdf/' + context.state.idItemSelected)
              .then(r => {
                if (r.status === 0) {
                  window.URL = window.URL || window.webkitURL;
                  var xhr = new XMLHttpRequest(), a = document.createElement('a'), file;
                  xhr.open('GET', r.data.url, true);
                  xhr.responseType = 'blob';
                  xhr.onload = function () {
                    file = new Blob([xhr.response], { type : 'application/octet-stream' });
                    a.href = window.URL.createObjectURL(file);
                    a.download = r.data.filename;  
                    a.click();
                  };
                  xhr.send();
                }
                NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
                context.props.setLoader(false)
              }).catch(e => {
                context.props.setLoader(false)
              })
          },
          renderIf: () => { return context.state.idItemSelected }
        }
      ]
    },

    columns: [
      {
        Header: "ID",
        accessor: "ID"
      },
      {
        Header: "Estado",
        accessor: "status",
        type: 'chip',
        chips: {
          '0': {text:'INICIADO',color:'red'},
          '1': {text:'EN PROCESO',color:'orange'},
          '2': {text:'FINALIZADO',color:'green'}
        }
      },
      {
        Header: "Alumno",
        accessor: "user"
      },
      {
        Header: "Grado",
        accessor: "grado"
      },
      {
        Header: "Fecha",
        accessor: "dateFrom",
        isDate: true,
        format: "YYYY-MM-DD"
      },
      {
        Header: "Profesor",
        accessor: "masterName"
      },
      {
        Header: "Visto",
        accessor: "readOn",
        isDate: true
      },
      {
        Header: "Notificado PPFF",
        accessor: "notifOn"
      }
    ]
  }
}







